/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createRe } from '../../factoriesAny.js';
export var reDependencies = {
  typedDependencies,
  createRe
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRe.generated.js
// module id = 71fv
// module chunks = 3